class FunctionalHeader {
	constructor(navContainer) {
		this.container = navContainer;
		if (!this.container) return;
		this.mobileBtns = this.container.querySelectorAll('[data-btn]');
		this.mobileMenuContent = this.container.querySelector('[data-content=menu]');
		this.dropdownContent = this.container.querySelector('[data-content=dropdown]');
		this.langSwitcherContent = this.container.querySelector('[data-content=langSwitcher]');
		this.langSwitcherContent = this.container.querySelector('[data-content=lang-dropdown]');

		this.addListners();
	}

	addListners() {
		[].slice.call(this.mobileBtns).forEach((el) => {
			el.addEventListener('click', (e) => this.addActiveClasses(e.currentTarget.dataset.btn, e.currentTarget));
		});
	}

	addActiveClasses(contentToShow, eventTarget) {
		const content = this.container.querySelector(`[data-content=${contentToShow}]`);
		this.onOpenHamburgerMenu(eventTarget);
		this.openDropdownInsideMenu(eventTarget);
		this.onCloseHamburgerMenu(eventTarget);
		this.defaultToggleContent(content, eventTarget);
		this.toggleAriaAttr(content, eventTarget);
	}

	onOpenHamburgerMenu(eventTarget) {
		if (eventTarget.dataset.btn === 'menu' && !this.mobileMenuContent.classList.contains('open')) {
			this.container.classList.add('expanded');
			[].slice.call(this.mobileBtns).forEach((el) => {
				el.classList.remove('active');
			});	
			this.dropdownContent.classList.remove('open');
			this.langSwitcherContent.classList.remove('open');
		}
	}

	openDropdownInsideMenu(eventTarget) {
		if (eventTarget.dataset.btn === 'dropdown' && this.mobileMenuContent.classList.contains('open')) {
			this.dropdownContent.classList.toggle('open-inside-mobile');
		}
	}

	onCloseHamburgerMenu(eventTarget) {
		if (eventTarget.dataset.btn === 'menu' && this.mobileMenuContent.classList.contains('open')) {
			this.container.classList.remove('expanded');
			this.dropdownContent.classList.remove('open', 'open-inside-mobile');

			[].slice.call(this.mobileBtns).forEach((el) => {
				if (el.dataset.btn === 'dropdown') el.classList.remove('active');
			});
		}
	}

	defaultToggleContent(content, eventTarget) {
		content.classList.toggle('open');
		eventTarget.classList.toggle('active');
	}

	toggleAriaAttr(content, eventTarget) {
		if (content.classList.contains('open')) {
			eventTarget.setAttribute("aria-expanded", "true");
		} else {
			eventTarget.setAttribute("aria-expanded", "false");
		}
	}
}

export default FunctionalHeader;
